import savePredictorAlarmRanges from './savePredictorAlarmRanges';
import { combineEpicsWithNames } from '../../../utils/helpers';

export default combineEpicsWithNames({
  savePredictorAlarmRanges
});